module.exports = __webpack_public_path__ + "static/media/CollapseDown.87fe8748.svg";